import * as React from "react";
import {isFuture, parseISO} from "date-fns";

import {dateTimeFormat, formatDate, numberFormat, pluralize} from "@pg-mono/string-utils";

import {IRangeQuery} from "../../../request/IRangeQuery";

interface IProps {
    fontSize?: string;
    offer: {
        buildings: number;
        construction_date_range: IRangeQuery<string>;
        floors_above_ground_range: IRangeQuery<number> | null;
        floors_below_ground: number | null;
        name: string;
        properties: number;
        stats: {
            properties_count_for_sale: number;
            ranges_area_min: number;
            ranges_area_max: number;
            ranges_price_m2_min: number;
        } | null;
    };
}

export const OfferGeneratedDescriptionTextCommercials: React.FunctionComponent<IProps> = (props) => {
    const {offer} = props;

    const futureEndDate = isFuture(parseISO(props.offer.construction_date_range.upper));
    const futureStartDate = isFuture(parseISO(props.offer.construction_date_range.lower));

    const upper = formatDate(props.offer.construction_date_range.upper, dateTimeFormat.quarter);
    const propertiesPlural = pluralize(["nowego lokalu użytkowego", "nowych lokali użytkowych", "nowych lokali użytkowych"]);
    //commercials
    const commercialsPlural = pluralize(["nowy lokal użytkowy", "nowe lokale użytkowe", "nowych lokali użytkowych"]);
    // others
    const arePlural = pluralize(["jest", "są", "jest"]);

    return (
        <>
            <p>
                {futureEndDate || !upper
                    ? `Inwestycja obecnie jest w trakcie ${futureStartDate ? "planowania" : "budowy"} ${
                          upper && `z planowanym na ${upper} roku terminem oddania do użytkowania`
                      }`
                    : `Inwestycja ${offer.name} została wybudowana i oddana do użytkowania ${upper && `w ${upper} roku`}`}
                .
            </p>

            {offer.properties && (
                <p>
                    Cały projekt składa się z {offer.properties} {propertiesPlural(offer.properties)}.
                </p>
            )}

            <p>
                {!!offer.stats?.properties_count_for_sale ? (
                    <>
                        Aktualnie w inwestycji {offer.name} w sprzedaży {arePlural(offer.stats.properties_count_for_sale)}{" "}
                        {offer.stats.properties_count_for_sale} {commercialsPlural(offer.stats.properties_count_for_sale)}
                        {!!offer.stats.ranges_area_min &&
                            ` o powierzchni ${
                                offer.stats.ranges_area_min === offer.stats.ranges_area_max
                                    ? `${offer.stats.ranges_area_min}`
                                    : `od ${offer.stats.ranges_area_min} do ${offer.stats.ranges_area_max}`
                            } metrów kwadratowych`}
                        {offer.stats.ranges_price_m2_min ? `, w cenie od ${numberFormat(offer.stats.ranges_price_m2_min)} zł za metr kwadratowy` : ""}.
                    </>
                ) : (
                    <>Aktualnie w inwestycji {offer.name} nie ma nowych lokali użytkowych w sprzedaży.</>
                )}
            </p>
        </>
    );
};
import * as React from "react";
import {isFuture, parseISO} from "date-fns";

import {dateTimeFormat, formatDate, numberFormat, pluralize} from "@pg-mono/string-utils";

import {IRangeQuery} from "../../../request/IRangeQuery";

interface IProps {
    fontSize?: string;
    offer: {
        buildings: number;
        construction_date_range: IRangeQuery<string>;
        floors_above_ground_range: IRangeQuery<number> | null;
        floors_below_ground: number | null;
        name: string;
        properties: number;
        stats: {
            properties_count_for_sale: number;
            ranges_area_min: number;
            ranges_area_max: number;
            ranges_price_m2_min: number;
        } | null;
    };
}

export const OfferGeneratedDescriptionTextCommercials: React.FunctionComponent<IProps> = (props) => {
    const {offer} = props;

    const futureEndDate = isFuture(parseISO(props.offer.construction_date_range.upper));
    const futureStartDate = isFuture(parseISO(props.offer.construction_date_range.lower));

    const upper = formatDate(props.offer.construction_date_range.upper, dateTimeFormat.quarter);
    const propertiesPlural = pluralize(["nowego lokalu użytkowego", "nowych lokali użytkowych", "nowych lokali użytkowych"]);
    //commercials
    const commercialsPlural = pluralize(["nowy lokal użytkowy", "nowe lokale użytkowe", "nowych lokali użytkowych"]);
    // others
    const arePlural = pluralize(["jest", "są", "jest"]);

    return (
        <>
            <p>
                {futureEndDate || !upper
                    ? `Inwestycja obecnie jest w trakcie ${futureStartDate ? "planowania" : "budowy"} ${
                          upper && `z planowanym na ${upper} roku terminem oddania do użytkowania`
                      }`
                    : `Inwestycja ${offer.name} została wybudowana i oddana do użytkowania ${upper && `w ${upper} roku`}`}
                .
            </p>

            {offer.properties && (
                <p>
                    Cały projekt składa się z {offer.properties} {propertiesPlural(offer.properties)}.
                </p>
            )}

            <p>
                {!!offer.stats?.properties_count_for_sale ? (
                    <>
                        Aktualnie w inwestycji {offer.name} w sprzedaży {arePlural(offer.stats.properties_count_for_sale)}{" "}
                        {offer.stats.properties_count_for_sale} {commercialsPlural(offer.stats.properties_count_for_sale)}
                        {!!offer.stats.ranges_area_min &&
                            ` o powierzchni ${
                                offer.stats.ranges_area_min === offer.stats.ranges_area_max
                                    ? `${offer.stats.ranges_area_min}`
                                    : `od ${offer.stats.ranges_area_min} do ${offer.stats.ranges_area_max}`
                            } metrów kwadratowych`}
                        {offer.stats.ranges_price_m2_min ? `, w cenie od ${numberFormat(offer.stats.ranges_price_m2_min)} zł za metr kwadratowy` : ""}.
                    </>
                ) : (
                    <>Aktualnie w inwestycji {offer.name} nie ma nowych lokali użytkowych w sprzedaży.</>
                )}
            </p>
        </>
    );
};
